<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<router-link :to="{ name: 'zlgl_cpzl_cpgl' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到商品列表</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="pt-a">
				<div class="d-flex" style="width: 100%;">
					<div style="width: 33%;">
						<el-form-item label="产品名称"><el-input v-model="lists.cpmc" style="width: 95%;" disabled></el-input></el-form-item>
						<el-form-item label="规格名称"><el-input v-model="gg.name" style="width: 95%;" disabled></el-input></el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="产品编码"><el-input v-model="lists.cpbm" placeholder="自动生成" style="width: 95%;" disabled></el-input></el-form-item>
						<el-form-item label="规格编码"><el-input v-model="gg.ggbm" style="width: 95%;" disabled></el-input></el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="计量单位"><el-input v-model="jldw" placeholder="自动生成" style="width: 95%;" disabled></el-input></el-form-item>
					</div>
				</div>
				<div class="d-flex" style="width: 100%;">
					<div style="width: 33%;">
						<el-form-item label="产品名称">
							<el-button type="primary" icon="el-icon-search" size="mini">{{ lists.cpmc }}</el-button>
						</el-form-item>
					</div>
					<div style="width: 64%;">
						<el-form-item label="原料信息">
							<el-table :data="bom" border style="width: 100%" size="mini">
								<el-table-column prop="id" label="编号" width="80"></el-table-column>
								<el-table-column prop="wlmc" label="物料名称" width="150"></el-table-column>
								<el-table-column prop="wlbm" label="物料编码" width="150"></el-table-column>
								<el-table-column align="center">
									<template slot="header" slot-scope="scope">
										数量
									</template>
									<template slot-scope="scope">
										<el-input-number v-model="scope.row.num" size="small"></el-input-number>
									</template>
								</el-table-column>
								<el-table-column prop="dw" label="单位" align="center" width="80"></el-table-column>
								<el-table-column align="center" width="80">
									<template slot="header" slot-scope="scope">
										<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
									</template>
									<template slot-scope="scope">
										<el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</div>
				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>

		<el-dialog title="类别详情" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-tabs v-model="tabIndex" @tab-click="getList"><el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane></el-tabs>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="cpgllist" tooltip-effect="dark" style="width: 100%;height: 400px;overflow-y: auto;" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="id" label="编号" width="50" align="center"></el-table-column>
					<el-table-column label="图片" width="70" align="center">
						<template slot-scope="scope">
							<div><img :src="scope.row.cptp" style="width: 30px;height: 30px;" /></div>
						</template>
					</el-table-column>
					<el-table-column prop="cpmc" label="产品名称" width="150"></el-table-column>
					<el-table-column prop="cpbm" label="产品编码" align="center"></el-table-column>
					<el-table-column align="center" label="产品类型">
						<template slot-scope="scope">
							<el-button type="info" size="mini" plain v-if="scope.row.cplx == 0">常规商品</el-button>
							<el-button type="success" size="mini" plain v-else-if="scope.row.cplx == 1">生产成品</el-button>
							<el-button type="danger" size="mini" plain v-else>生产原料</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="jldw.name" label="计量单位" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common],
	inject: ['app', 'layout'],
	data() {
		return {
			preUrl: 'cpgl',
			cpgllist: [],
			lists: {},
			gg: {},
			jldw: '',
			createModel: false,
			tabbars: [{ name: '全部产品', key: 'all' }, { name: '生产成品', key: 'sccp' }, { name: '生产原料', key: 'scyl' }],
			tabIndex: 0,
			bom:[],
			multipleSelection: []
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		}),
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	created() {
		this.lists = this.$route.params.data;
		this.axios.get('/admin/cpgg/' + this.lists.cpgg + '/one', { token: true }).then(res => {
			this.gg = res.data.data;
		});
		this.axios.get('/admin/cpdw/' + this.lists.jldw + '/one', { token: true }).then(res => {
			this.jldw = res.data.data.name;
		});
		this.getbom()
	},
	methods: {
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.cpgllist = e.list;
		},
		getbom(){
			this.axios.get('/admin/cpbom/' + this.lists.id, { token: true }).then(res => {
				this.bom = res.data.data;
			});
		},
		pustyl() {
			this.createModel = true;
		},
		chooseImage() {
			this.app.chooseImage(res => {
				this.form.cover = res[0].url;
			}, 1);
		},
		submits(e) {
			let x = e.map(i=>{
				return {
					cpid:this.lists.id,
					wlmc:i.cpmc,
					wlbm:i.cpbm,
					cjr:this.user.id,
					dw:i.jldw.name,
					cpidd:i.id
				}
			})
			this.axios.post('/admin/cpbom', {ids:x},{
				token: true
			}).then(res => {
				this.getbom()
				this.createModel = false;
			})
		},
		submit() {
			this.axios.post('/admin/cpbom/ids', this.bom,{
				token: true
			}).then(res => {
				this.$message({
					type: "success",
					message: "添加成功"
				})
				this.$router.push({
					name: "zlgl_cpzl_cpgl"
				})
			})
			
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
</style>
